/**
 * Extracts a user-friendly error message from various error response formats.
 * Handles both structured error objects (with message property) and string errors.
 * 
 * @param error - The error object from HTTP response (error.data) or error object itself
 * @param fallbackMessage - Optional fallback message if error cannot be extracted
 * @returns A string error message suitable for display to users
 */
export function extractErrorMessage(error: any, fallbackMessage: string = "An error occurred"): string {
  if (!error) {
    return fallbackMessage;
  }

  // If error.data exists (from HTTP response), extract from it
  if (error.data !== undefined) {
    const errorData = error.data;
    
    // If it's already a string, return it
    if (typeof errorData === "string") {
      return errorData;
    }
    
    // If it's an object, try to extract the message
    if (typeof errorData === "object" && errorData !== null) {
      if (errorData.message) {
        return errorData.message;
      }
      if (errorData.error) {
        return typeof errorData.error === "string" 
          ? errorData.error 
          : (errorData.error && errorData.error.message) || fallbackMessage;
      }
      if (errorData.errorMessage) {
        return errorData.errorMessage;
      }
    }
  }

  // If error itself is a string, return it
  if (typeof error === "string") {
    return error;
  }

  // If error is an object, try to extract message
  if (typeof error === "object" && error !== null) {
    if (error.message) {
      return error.message;
    }
    if (error.error) {
      return typeof error.error === "string" 
        ? error.error 
        : (error.error && error.error.message) || fallbackMessage;
    }
    if (error.errorMessage) {
      return error.errorMessage;
    }
  }

  // Fallback
  return fallbackMessage;
}



// WEBPACK FOOTER //
// ./src/app/common/utils/errorUtils.ts